export const validateField = (value, setIsError, inputRef) => {
    if (value.trim() === "") {
        setIsError(true);
        inputRef.current.focus();
        inputRef.current.scrollIntoView({ behavior: "smooth" });
        return false;
    }
    return true;
};
